import { render, staticRenderFns } from "./pipei.vue?vue&type=template&id=bab0a322&scoped=true"
import script from "./pipei.vue?vue&type=script&lang=js"
export * from "./pipei.vue?vue&type=script&lang=js"
import style0 from "./pipei.vue?vue&type=style&index=0&id=bab0a322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab0a322",
  null
  
)

export default component.exports